export default {
    //获取地图周围的客户列表
    getMapCompany(state) {
        if (state.is_sales) return "companyInterfaces/v1.0/getPlatformSaleMapCompanyList";//大S
        if (state.is_platform_technician) return "companyInterfaces/v1.0/getPlatformTechnicianMapCompanyList";//大F
        if (state.is_technician) return "companyInterfaces/v1.0/getTechnicianMapCompanyList";//小F
        return "";
    },
    //获取大/小S客户列表
    getSaleCompanyList(state) {
        if (state.is_sales) return "saleInterfaces/v1.0/getSaleCompanyList";//大S
        if (state.is_part_time_sale) return "saleInterfaces/v1.0/getSaleCompanyList";//小S
        return "";
    },
    //添加巡检表
    addCompanyInspection(state) {
        if (state.is_sales) return "app/companyInspection/platformSaleAddCompanyInspection";//大S
        if (state.is_platform_technician) return "app/companyInspection/platformTechnicianAddCompanyInspection";//大F
        if (state.is_technician) return "app/companyInspection/technicianAddCompanyInspection";//小F
        return "";
    },
    //获取订单列表
    getOrderList(state) {
        if (state.is_sales) return "orderInterfaces/v1.0/getPlatformSaleOrderList";//大S
        if (state.is_platform_technician) return "orderInterfaces/v1.0/getPlatformTechnicianOrderList";//大F
        if (state.is_technician) return "orderInterfaces/v1.0/getTechnicianOrderList";//小F
        if (state.is_company) return "orderInterfaces/v1.0/getCompanyOrderList";//客户
        return "";
    },
    //获取订单详情
    getOrderDetail(state) {
        if (state.is_sales) return "orderInterfaces/v1.0/getSaleOrderDetail";//大S
        if (state.is_company) return "orderInterfaces/v1.0/getOrderDetail";//客户
        return "";
    },
    //获取服务人员服务订单
    getServiceOrderList(state) {
        if (state.is_sales) return 'serviceInterfaces/v1.0/getSellOrders';//大S
        if (state.is_platform_technician) return "serviceInterfaces/v1.0/getPlatformTechnicianServiceOrderList";//大F
        if (state.is_technician) return "serviceInterfaces/v1.0/getTechnicianServiceOrderList";//小F
        return "";
    },
    //小S，小F获取收益信息
    getIncomeInfo(state) {
        if (state.is_part_time_sale) return "app/memberBalance/getSalesIncomeInfo";//小S
        if (state.is_technician) return "app/memberBalance/getTechnicianIncomeInfo";//小F
        return "";
    },
    //收益记录列表
    getBalanceRecordList(state) {
        if (state.is_part_time_sale) return "app/memberBalance/getSaleBalanceRecordList";//小S
        if (state.is_technician) return "app/memberBalance/getTechnicianBalanceRecordList";//小F
        return "";
    },
    //获取下级兼职销售
    getMySaleList(state) {
        if (state.is_sales) return "memberInterfaces/v1.0/platformGetMySubSaleList";//大S
        if (state.is_part_time_sale) return "memberInterfaces/v1.0/getMySubSaleList";//客户
        return "";
    },
    //获取下级兼职服务
    getMyTechnicianList(state) {
        if (state.is_sales) return "memberInterfaces/v1.0/platformGetMySubTechnicianList";//大S
        if (state.is_part_time_sale) return "memberInterfaces/v1.0/getMySubTechnicianList";//客户
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js